import React, { Component } from 'react'
import { Translate } from '../../contexts/LanguageContext';
import { WithdrawalService } from '../../services/WithdrawalService';
import { Link } from 'react-router-dom';
import { Loading, ErrorMessage } from '../../components';

export class Verification extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            validation: {
                error: false,
                message: Translate('Your verification request is processing..')
            },
            token: ""
        }
    }
    componentDidMount() {
        this.setState({ loading: true }, () => {

            const param = window.location.search.replace('?', '').split('=');

            if (param.length === 2 && param[0] === "token") {
                let token = param[1];
                WithdrawalService.Verification({
                    token: token
                }).then(response => {
                    this.setState({
                        loading: false,
                        validation: response
                    });

                });
            }
            else {
                window.location.href = "/login";
            }

        });
    }
    render() {
        return (
            <React.Fragment>
                <Loading Show={this.state.loading} Title={Translate('Your verification request is processing..')} />
                <div className="wrapper-page">
                    <div className="card account-card mx-3">
                        <div className="bg-primary p-4 text-white text-center position-relative">
                            <h4 className="font-20 m-b-5">{Translate('Customer Panel')}</h4>
                            <p className="text-white-50 mb-4">{Translate('Withdrawal Verification Panel')}</p>
                            <Link to="/login" className="logo logo-admin"><img src="../assets/images/logo/logo-icon.svg" height="48" alt="logo" /></Link>
                        </div>
                        <div className="account-card-content">
                            <div className={"alert alert-primary alert-dismissible fade mb-0 show mt-4"} role="alert">
                                {Translate(this.state.validation.message)}
                            </div>
                            <ErrorMessage Validation={this.state.validation} />
                        </div>
                    </div>
                    <div className="m-t-40 text-center">
                        <p>© {new Date().getFullYear()} ARTSMRKTS </p>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}